import script from "./NavButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavButtons.vue?vue&type=script&setup=true&lang=ts"

import "./NavButtons.vue?vue&type=style&index=0&id=27d70d44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27d70d44"]])

export default __exports__